// 深拷贝
function deepCopy (obj) {
  if (!obj) return
  var newObj
  try {
    newObj = obj.constructor && obj.constructor === Array ? [] : {}
    newObj.constructor = obj.constructor
  } catch (e) {
    newObj = []
  }
  if (typeof obj !== 'object') {
    return
  } else {
    for (var prop in obj) {
      if (!obj[prop] || obj[prop].constructor === RegExp || obj[prop].constructor === Date) {
        newObj[prop] = obj[prop]
      } else if (typeof obj[prop] === 'object') {
        // 递归
        newObj[prop] = deepCopy(obj[prop])
      } else {
        newObj[prop] = obj[prop]
      }
    }
  }
  return newObj
}

// 随机id
function generateUgid () {
  let d = new Date().getTime()
  let uuid = 'axxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
  })
  return uuid
}

// 中国标准时间格式化为 xxxx-xx-xx xx:xx:xx
function dateFormat (d) {
  // return d = d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate());
  return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())
}

// 处理表格里的日期 xxxx-xx-xxTxx:xx:xx00000 格式为 xxxx-xx-xx xx:xx:xx
function tableDateFormat (date) {
  return dateFormat(new Date(date))
}

// 处理UNIX()时间戳 格式为 xxxx-xx-xx xx:xx:xx
function unixDateFormat (date) {
  if (date === 0) {
    return null
  } else {
    var unixTimestamp = new Date(date * 1000)
    return dateFormat(unixTimestamp)
  }
}
function unixMilliDateFormat (date) {
  if (date === 0) {
    return null
  } else {
    var d = new Date(date)
    return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()) + ' ' + d.getMilliseconds()
  }
}
// 递归获取树 [{id: 1, parentId: null, name: '11'}, {id: 2, parentId: null, name: '22'}, {id: 3, parentId: 1, name: '33'}, {id: 4, parentId: 1, name: '44'}]
function getTreeData (data, idField, parentField, childField, oldNodeName, newNodeName) {
  // 删除 所有 children,以防止多次调用
  if (!childField) childField = 'childData'
  data.forEach(function (item) {
    delete item[childField]
  })

  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  var map = {}
  data.forEach(function (item) {
    map[item[idField]] = item
  })
  //        console.log(map)
  var val = []
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    var parent = map[item[parentField]]
    // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      if (!parent[childField]) parent[childField] = []
      // item[newNodeName] = item[oldNodeName] 如果需要函数定制节点名称 可放开注释
      parent[childField].push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      // item[newNodeName] = item[oldNodeName] 如果需要函数定制节点名称 可放开注释
      val.push(item)
    }
  })
  return val
}

const commonFun = {
  deepCopy,
  generateUgid,
  dateFormat,
  tableDateFormat,
  getTreeData,
  unixDateFormat,
  unixMilliDateFormat
}

export default commonFun



// WEBPACK FOOTER //
// ./src/common/function.js